var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoulders0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 181,
    viewBox: "0 0 212 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_725_49786)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1978 6.241C71.4206 5.4244 73.0463 5.41486 74.9787 5.91254C75.9195 18.3256 87.6603 24.986 106.087 24.986C124.319 24.986 136.104 18.467 137.27 6.30527C138.43 5.70643 141.514 5.38483 142.788 6.65414C142.788 6.65737 142.788 6.66059 142.788 6.66382C151.325 9.44502 159.891 12.3774 167.255 14.8985L167.255 14.8986C170.615 16.0488 173.725 17.1134 176.468 18.0389C192.386 23.4102 201.957 68.1353 205.639 99.0199C201.152 103.513 188.811 109.059 164.671 109.059C164.671 111.29 164.613 127.914 164.555 144.649L164.555 144.782L164.555 144.816C164.496 161.73 164.437 178.706 164.437 181H106H105.999H47.7209C47.7209 178.705 47.6084 161.811 47.4964 144.99C47.3854 128.314 47.2748 111.709 47.2748 109.472C23.1343 109.472 10.8468 103.513 6.35986 99.0199C10.0414 68.1353 19.6127 23.4102 35.5306 18.0389C38.2734 17.1134 41.3832 16.0488 44.7431 14.8986L44.7435 14.8985L44.7437 14.8984C52.392 12.2801 61.3362 9.21824 70.198 6.34283C70.1979 6.30891 70.1978 6.27496 70.1978 6.241Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0655 20.8486C16.7854 32.3761 8.64167 71.2811 5.2998 99.0208C9.55 103.705 23.1145 110.039 47.3142 110.094C46.7151 87.9577 46.5234 54.237 48.194 51.2714L48.2107 51.2421C47.2357 43.3839 40.8548 34.0318 35.3043 26.823C33.4772 24.45 31.6051 22.6885 30.0655 20.8486Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6297 119.723V120.263H47.6517C47.6443 120.085 47.637 119.905 47.6297 119.723Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.627 20.6211C195.191 31.3709 203.522 70.6401 206.864 98.3798C202.614 103.064 189.05 109.398 164.85 109.453C165.449 87.3167 165.641 53.5961 163.97 50.6304L163.953 50.6011C164.928 42.7429 171.309 33.3908 176.86 26.182C178.687 23.8091 180.088 22.4609 181.627 20.6211Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.534 119.082V119.622H164.512C164.52 119.444 164.527 119.264 164.534 119.082Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3992 17.4138C45.1352 14.0558 56.7292 9.89546 70.0251 5.87002C70.85 5.45778 73.4072 4.88064 75.3869 5.87C75.7993 13.2902 80.9194 18.9275 87.5185 21.8131C78.9625 26.5888 59.1135 39.0729 48.1656 50.8035C46.4884 43.2555 36.5357 27.9238 29.7764 20.9757C31.5217 19.2276 33.4329 18.092 35.3992 17.4138Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.612 17.4138C166.876 14.0558 155.282 9.89546 141.986 5.87002C141.161 5.45778 138.604 4.88064 136.624 5.87C136.211 13.2902 131.091 18.9275 124.492 21.8131C133.048 26.5888 152.897 39.0729 163.845 50.8035C165.522 43.2555 175.475 27.9238 182.234 20.9757C180.489 19.2276 178.578 18.092 176.612 17.4138Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3291 110.636C23.1679 110.636 9.52239 104.121 5.03165 99.5916C4.62268 97.5243 5.06578 93.4461 6.11632 91.2666C11.8298 96.2857 29.063 100.636 47.0689 101.155L47.3291 110.636Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.649 109.928C189.005 109.928 202.174 104.909 206.701 100.38C207.526 98.7231 207.113 93.3379 205.876 91.2666C200.116 96.2857 183.212 100.726 165.061 101.245L164.649 109.928Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.0377 5.68697C73.2072 4.99739 69.7369 5.54707 68.5479 6.29923C68.5479 21.4723 84.0614 31.6139 105.778 31.6139C127.494 31.6139 142.835 21.64 142.835 6.46696C141.582 5.21881 137.528 5.09879 136.125 5.59993C135.196 17.817 123.781 24.3702 106.026 24.3702C88.3129 24.3702 77.007 17.847 76.0377 5.68697Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.87266,
    y1: 185.298,
    x2: 222.127,
    y2: -8.7015,
    stroke: "#D82626",
    strokeWidth: 15
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_725_49786"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 212,
    height: 181,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoulders0);
export default __webpack_public_path__ + "static/media/Shoulders 0.952d38ede55ec63cbba28546fb69a095.svg";
export { ForwardRef as ReactComponent };